export default __webpack_public_path__ + "static/service-rtv-agd-c0d660af6ac0ee9c48bacbaf99fc05c9.svg";